module.exports = __webpack_public_path__ + "img/send1.ec6aebdf.png";